import { Typography, Stack } from "@mui/material";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import {
  PROVIDER_INFO_EMAIL,
  PROVIDER_INFO_FIRST_NAME,
  PROVIDER_INFO_LAST_NAME,
  PROVIDER_INFO_MIDDLE_NAME,
  PROVIDER_INFORMATION_HEADER,
} from "../../../Constants/ProviderAndCertifierAccountCreationConstants";
import { H2, VARIANT_H4 } from "../../../Constants/CommonConstants";
import { manageProviderAccountCreationSelector } from "../../../Selectors/ProviderAccountCreationSelector";
import { PersonalInfoFieldDisplay } from "./PersonalInfoFieldDisplay";
import { StyledPersonalInfoFieldGrid } from "../../../Styles/AccountCreation/ProviderAndCertifierAccountCreation/ProviderReviewInfoStyles";

/**
 * @description Provider Personal Information Fields.
 * @returns {ReactNode} Renders the Provider Personal Information Fields
 */
export const PersonalInformation = () => {
  const { firstName, middleName, lastName, email } = useSelector((state) =>
    manageProviderAccountCreationSelector(state)
  );

  const intl = useIntl();

  return (
    <Stack spacing={6}>
      <Stack spacing={3}>
        <Typography
          component={H2}
          variant={VARIANT_H4}
          id={PROVIDER_INFORMATION_HEADER}
        >
          {intl.formatMessage({
            id: PROVIDER_INFORMATION_HEADER,
          })}
        </Typography>
        <StyledPersonalInfoFieldGrid container spacing={2}>
          <PersonalInfoFieldDisplay
            fieldLabel={PROVIDER_INFO_FIRST_NAME}
            fieldValue={firstName}
          />
          <PersonalInfoFieldDisplay
            fieldLabel={PROVIDER_INFO_MIDDLE_NAME}
            fieldValue={middleName}
          />
        </StyledPersonalInfoFieldGrid>
        <StyledPersonalInfoFieldGrid container spacing={2}>
          <PersonalInfoFieldDisplay
            fieldLabel={PROVIDER_INFO_LAST_NAME}
            fieldValue={lastName}
          />
          <PersonalInfoFieldDisplay
            fieldLabel={PROVIDER_INFO_EMAIL}
            fieldValue={email}
          />
        </StyledPersonalInfoFieldGrid>
      </Stack>
    </Stack>
  );
};
